import React, { Component } from "react";
import styled from "styled-components";
import firebase from "firebase";
import { Link } from "react-router-dom";

import liveChatLogo from "./../lib/assets/liveChat/liveChatLogo.svg";
import liveChatAdd from "./../lib/assets/liveChat/add.svg";

import { fromUnixTime, formatDistance } from "date-fns";

import UserCard from "./UserCard";
import ChatView from "./ChatView";

const RootContainer = styled.div`
  display: flex;
  min-height: 600px;
`;

const AllMsgRootContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  max-height: 600px;
  max-width: 400px;
  min-width: 350px;
  overflow-y: auto;
  padding: 0 20px 20px 0;
  width: 100%;
  > a {
    text-decoration: none;
  }
`;

const AllMsgHeading = styled.h2`
  color: #000000;
  margin-top: 0;
`;

const AllMsgContainer = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 120px;
  margin-bottom: 20px;
  padding: 20px;
  position: relative;
`;

const AllMsgEmailTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const AllMsgUserEmail = styled.h4`
  color: #46494c;
  margin: 0;
`;

const AllMsgUserTimeAgo = styled.h4`
  color: #6d7278;
  margin: 0;
`;

const AllMsgUserText = styled.p`
  color: #6d7278;
  font-weight: 300;
`;

const AllMsgStatus = styled.div`
  align-items: center;
  background-color: ${(props) => (props.closed ? "#272D2D" : "#EDBA5D")};
  border-radius: 10px 0 0 0;
  bottom: 0;
  color: #ffffff;
  display: flex;
  font-size: 12px;
  font-weight: 500;
  height: 27px;
  justify-content: center;
  position: absolute;
  right: 0;
  width: 60px;
`;

const LiveChatMsgRootContainer = styled.div`
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
`;

const LiveChatLogoContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 50px;
  width: 100%;
`;

const LiveChatLogo = styled.img`
  display: block;
  height: 50px;
`;

const LiveChatConversation = styled.div`
  border-bottom-color: #e2e2e2;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
`;
const LiveChatSupportBubbleRootContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const LiveChatSupportBubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const LiveChatSupportBubble = styled.div`
  background-color: #272d2d;
  border-radius: 10px 10px 0 10px;
  color: #ffffff;
  padding: 20px;
`;

const LiveChatUserBubbleRootContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

const LiveChatUserBubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const LiveChatUserBubble = styled.div`
  background-color: #edba5d;
  border-radius: 10px 10px 10px 0;
  color: #ffffff;
  padding: 20px;
`;

const LiveChatMsgTime = styled.p`
  text-align: ${(props) => (props.endBadge ? "right" : "left")};
`;

const SendMsgContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 40px;
  padding-top: 20px;
`;

const SendMsgAdd = styled.img`
  height: 24px;
  margin-right: 20px;
`;

const SendMsgTextInput = styled.input`
  border: none;
  display: flex;
  flex: 1;
`;

const SendMsgButton = styled.button`
  background-color: #edba5d;
  border-radius: 8px;
  color: #ffffff;
  height: 24px;
  margin-left: 20px;
`;

const CloseLiveChatButton = styled.button`
  background-color: #272d2d;
  border-radius: 8px;
  color: #ffffff;
  height: 24px;
  margin-left: 20px;
  width: 60px;
`;

const ChatViewModal = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #00000090;
  justify-content: center;
  flex-direction: column;
`;

const CloseWindosButton = styled.button`
  background-color: #f44336;
  border-radius: 8px;
  color: #ffffff;
  height: 24px;
  margin-left: 20px;
  width: 140px;
  display: flex;
  align-self: flex-end;
  margin-right: 20px;
  justify-content: center;
  align-items: center;
  border: none;
`;

class LiveChat extends Component {
  constructor() {
    super();

    this.state = { users: [], showTicket: "", isChatViewVisible: false };
  }

  handleClickOnTicket = (userId) => {
    console.log("_______clicked", userId);
    const state = { ...this.state };

    state.isChatViewVisible = true;
    state.showTicket = userId;

    this.setState({ ...state });
  };

  handleConvertDate = (date) => {
    const result = formatDistance(new Date(), new Date(date));
    return result;
  };

  handleCloseTicket = () => {
    const state = { ...this.state };

    state.isChatViewVisible = false;
    state.showTicket = "";

    this.setState({ ...state }, this.fetchAllTickets());
  };

  fetchAllTickets = () => {
    const db = firebase.firestore();
    const ref = db.collection("livechat").orderBy("created", "asc").get();

    ref.then((snap) => {
      snap.forEach((doc) => {
        console.log("________doc id", doc.data());
        this.setState({ users: [...this.state.users, doc.data()] });
      });
    });
  };

  componentDidMount() {
    // this.fetchAllTickets();
    const db = firebase.firestore();
    this.listener = db.collection("livechat").onSnapshot((snapShot) => {
      console.log("_______snapShot", snapShot);

      snapShot.docChanges().forEach((change) => {
        console.log("___________change3333", change);
        console.log("___________change data", change.doc.data());

        if (change.type === "added") {
          console.log("______change----++++++++", change.doc.data());
          console.log("______change----++++++++", change.doc.id);
          const state = { ...this.state };
          state.users.push(change.doc.data());
          // state.users.sort((a, b) => (a.created > b.created ? -1 : 1));

          state.users.sort((a, b) =>
            a.created > b.created
              ? -1
              : a.created === b.created
              ? a.statusClosed > b.statusClosed
                ? 1
                : -1
              : 1
          );

          this.setState({ ...state });
          // this.setState({ users: [...this.state.users, change.doc.data()] });
        }
        if (change.type === "modified") {
          const modifiedUserIndex = this.state.users.findIndex((user) => {
            if (user.uid == change.doc.id) {
              return user;
            }
          });
          console.log("______modifiedUserIndex", modifiedUserIndex);
          const state = { ...this.state };
          state.users[modifiedUserIndex].lastMsg = change.doc.data().lastMsg;
          state.users[modifiedUserIndex].created = change.doc.data().created;
          state.users[
            modifiedUserIndex
          ].statusClosed = change.doc.data().statusClosed;

          state.users.sort((a, b) => (a.created > b.created ? -1 : 1));
          this.setState({ ...state });
        }
      });
    });
  }
  componentWillUnmount() {
    this.listener();
  }
  render() {
    return (
      <RootContainer>
        <AllMsgRootContainer>
          <AllMsgHeading>All messages </AllMsgHeading>
          {this.state.users.map((user, index) => {
            console.log("_______user", user);

            return (
              <Link to={`/livechatid/${user.uid}`} key={user.uid}>
                <UserCard
                  key={user.uid}
                  userId={user.uid}
                  userEmail={user.userEmail}
                  lastMsg={user.lastMsg}
                  created={user.created}
                  statusClosed={user.statusClosed}
                  handleClickOnTicket={this.handleClickOnTicket}
                  handleConvertDate={this.handleConvertDate}
                />
              </Link>
            );
          })}
        </AllMsgRootContainer>
        {this.state.isChatViewVisible ? (
          <ChatViewModal>
            <CloseWindosButton onClick={() => this.handleCloseTicket()}>
              Close chat window
            </CloseWindosButton>
            <LiveChatMsgRootContainer>
              {this.state.showTicket ? (
                <ChatView ticketId={this.state.showTicket} />
              ) : null}
            </LiveChatMsgRootContainer>
          </ChatViewModal>
        ) : null}
      </RootContainer>
    );
  }
}
export default LiveChat;
